import * as types from "../../mutation-types";
import {removeItem, addOrUpdateItem} from "../../helpers";

export default {
    // [types.SET_SERVICES]: (state, items) => Vue.set(state, 'items', items),
    [types.SET_SERVICES]: (state, items) => state.items = items,
    [types.ADD_OR_UPDATE_SERVICE]: (state, item) => addOrUpdateItem(state, item),
    [types.REMOVE_SERVICE]: (state, item) => removeItem(state, item)
}